/* Albindress — predictive-search.js
   Combobox accessibile basato sulla Predictive Search API di Shopify. */
(function () {
  'use strict';

  const SG = (window.Albin = window.Albin || {});
  if (customElements.get('predictive-search')) return;

  customElements.define(
    'predictive-search',
    class PredictiveSearch extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[type="search"]');
        this.results = this.querySelector('[data-predictive-results]');
        this.status = this.querySelector('[data-predictive-status]');
        if (!this.input || !this.results) return;
        this.cache = new Map();
        this.abortController = null;

        this.input.addEventListener(
          'input',
          SG.debounce(() => this.onInput(), 250)
        );
        this.input.addEventListener('keydown', (event) => this.onKeydown(event));
        this.input.addEventListener('focus', () => {
          if (this.input.value.trim() && this.results.innerHTML.trim()) this.open();
        });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.close();
        });
        this.results.addEventListener('mousedown', (event) => {
          // evita la perdita di focus prima del click sul risultato
          if (event.target.closest('a')) event.preventDefault();
        });
        this.results.addEventListener('click', (event) => {
          const link = event.target.closest('a');
          if (link) window.location.href = link.href;
        });
      }

      get options() {
        return Array.from(this.results.querySelectorAll('[role="option"]'));
      }

      async onInput() {
        const term = this.input.value.trim();
        if (!term) {
          this.close(true);
          return;
        }
        if (this.cache.has(term)) {
          this.render(this.cache.get(term));
          return;
        }
        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();
        const params = new URLSearchParams({
          q: term,
          'resources[type]': 'product,collection,page,article,query',
          'resources[limit]': '4',
          'resources[limit_scope]': 'each',
          section_id: 'predictive-search',
        });
        try {
          const response = await fetch(SG.routes.predictiveSearch + '?' + params.toString(), {
            signal: this.abortController.signal,
          });
          if (!response.ok) throw new Error(String(response.status));
          const html = await response.text();
          const doc = SG.parseHTML(html);
          const content = doc.querySelector('#PredictiveSearchResults');
          const payload = {
            html: content ? content.innerHTML : '',
            total: content ? parseInt(content.dataset.total, 10) || 0 : 0,
          };
          this.cache.set(term, payload);
          if (this.input.value.trim() === term) this.render(payload);
        } catch (error) {
          if (error.name !== 'AbortError') this.close(true);
        }
      }

      render(payload) {
        this.results.innerHTML = payload.html;
        const prefix = this.results.id;
        this.results.querySelectorAll('[role="option"]').forEach((option, i) => {
          option.id = prefix + '-option-' + (i + 1);
        });
        if (payload.total > 0) {
          this.results.setAttribute('role', 'listbox');
          this.results.setAttribute('aria-label', this.input.getAttribute('placeholder') || '');
        } else {
          this.results.removeAttribute('role');
          this.results.removeAttribute('aria-label');
        }
        this.open();
        if (this.status) {
          const template = this.dataset.statusTemplate || '[count]';
          this.status.textContent = template.replace('[count]', payload.total);
        }
      }

      open() {
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
      }

      close(clear) {
        this.results.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
        if (clear) this.results.innerHTML = '';
      }

      onKeydown(event) {
        const options = this.options;
        const isOpen = !this.results.hidden;
        if (event.key === 'Escape') {
          if (isOpen) {
            event.preventDefault();
            event.stopPropagation();
            this.close();
          } else if (this.input.value) {
            event.preventDefault();
            this.input.value = '';
            this.close(true);
          }
          return;
        }
        if (!isOpen || !options.length) return;

        const current = options.findIndex((o) => o.getAttribute('aria-selected') === 'true');
        let next = current;
        if (event.key === 'ArrowDown') next = current + 1 >= options.length ? 0 : current + 1;
        else if (event.key === 'ArrowUp') next = current - 1 < 0 ? options.length - 1 : current - 1;
        else if (event.key === 'Enter' && current >= 0) {
          event.preventDefault();
          window.location.href = options[current].href;
          return;
        } else return;

        event.preventDefault();
        options.forEach((o, i) => o.setAttribute('aria-selected', String(i === next)));
        const selected = options[next];
        this.input.setAttribute('aria-activedescendant', selected.id);
        selected.scrollIntoView({ block: 'nearest' });
      }
    }
  );
})();
